<template lang="html">
    <li class="main-menu__item has-dropright">
        <a>
            <span>Цены</span>
        </a>
        <div class="main-menu__item__dropright-menu">
            <div class="main-menu__item__dropright-menu__container">
                <div class="main-menu__item__dropright-menu__section">
                    <h4 class="main-menu__item__dropright-menu__title">Цены</h4>
                    <router-link v-bind:to="{ name: 'Prices' }">Стоимость перевозки</router-link>
                    <router-link v-bind:to="{ name: 'Extrasizes' }">Негабаритный груз</router-link>
                    <router-link v-bind:to="{ name: 'PaymentMethods' }">Способы оплаты</router-link>
                    <router-link v-bind:to="{ name: 'Cities' }">Населённые пункты</router-link>
                    <router-link v-bind:to="{ name: 'Zones' }">Направления</router-link>
                    <!-- <router-link v-bind:to="{ name: 'Discounts' }">Скидки</router-link> -->
                </div>

                <div class="main-menu__item__dropright-menu__section">
                    <h4 class="main-menu__item__dropright-menu__title">Услуги</h4>
                    <router-link v-bind:to="{ name: 'DoomPrices' }">Обрешётка</router-link>
                    <router-link v-bind:to="{ name: 'LuwPrices' }">Погрузочно-разгрузочные работы</router-link>
                    <router-link v-bind:to="{ name: 'ManipulatorPrices' }">Услуги манипулятора</router-link>
                    <router-link v-bind:to="{ name: 'AirportPrices' }">Представление интересов в аэропорту</router-link>
                    <router-link v-bind:to="{ name: 'StoragePrices' }">Сверхнормативное хранение</router-link>
                    <router-link v-bind:to="{ name: 'ForwardingPrices' }">Экспедирование</router-link>
                    <router-link v-bind:to="{ name: 'AdditionalServices' }">Дополнительные услуги</router-link>
                    <!-- <router-link v-bind:to="{ name: 'OtherSettings' }">Прочие параметры</router-link> -->
                </div>
            </div>
        </div>
    </li>
</template>
<script>
    export default {
        name: 'cost-settings-menu',
        sort: 2,
        module: 'cost',
        return() {
            return {
                module: 'cost'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SettingsMenu.vue?2886ac8c